"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./..");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Footer = () => {
  const tel = "1-513-278-3575";
  const telReference = "tel:" + tel;
  const mailTo = "mailto:you@indigenux.com";
  const socialMedia = {
    facebookHandle: "indigenux",
    twitterHandle: "indigenux",
    linkedInHandle: "indigenux",
    instagramHandle: "indigenux"
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("footer", {
    id: "footer",
    className: "footer-texts-more-lighten",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "row py-4 my-5",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col mb-5 mb-lg-0",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Heading, {
            level: "h5",
            cssName: "text-color-light",
            children: "CONTACT INFO"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
            className: "list list-unstyled",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              className: "pb-1 mb-2",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "d-block font-weight-normal line-height-1 text-color-light",
                children: "PHONE"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                iconClass: "fas fa-phone",
                href: telReference,
                children: tel
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              className: "pb-1 mb-2",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "d-block font-weight-normal line-height-1 text-color-light",
                children: "EMAIL"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Link, {
                iconClass: "far fa-envelope",
                href: mailTo,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "text-color-primary",
                  children: "you"
                }), "@indigenux.com"]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.SocialMediaNav, {
            facebookHandle: socialMedia.facebookHandle,
            twitterHandle: socialMedia.twitterHandle,
            linkedInHandle: socialMedia.linkedInHandle,
            instagramHandle: socialMedia.instagramHandle,
            className: "social-icons-clean-with-border social-icons-medium"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col mb-5 mb-lg-0",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Heading, {
            level: "h5",
            cssName: "text-color-light",
            children: "INFORMATION"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
            className: "list list-unstyled mb-0",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "mb-0",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                href: "contact-us",
                children: "Contact Us"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "mb-0",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                href: "services",
                children: "Services"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "mb-0",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                href: "cookies",
                children: "Cookies"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "mb-0",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                href: "privacy",
                children: "Privacy Policy"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "mb-0",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
                href: "terms",
                children: "Terms of Use"
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "footer-copyright footer-copyright-style-2 pt-4 pb-5",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "col-12 text-center",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
              className: "mb-0",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.IndiText, {
                uxCSSClass: "text-color-primary"
              }), " \xA9 2023. All Rights Reserved"]
            })
          })
        })
      })
    })]
  });
};
Footer.propTypes = {};
var _default = exports.default = Footer;